import React from 'react';
import { Input, Button } from 'antd';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';

const ResponsiveActionBar = ({ 
  title,
  searchValue,
  onSearchChange,
  onExportCSV,
  onExportPDF,
  exportLoading,
  extraActions,
  children 
}) => {
  return (
    <div className="responsive-action-bar mb-3">
      {/* Header Row with Title and Search/Export */}
      <div className="row align-items-center mb-3">
        {/* Title Column */}
        <div className="col-12 col-md-6">
          <h4 className="mb-0">{title}</h4>
        </div>
        
        {/* Search and Export Column - Right Aligned */}
        <div className="col-12 col-md-6">
          <div className="d-flex justify-content-md-end justify-content-start mt-2 mt-md-0 gap-2">
            {/* Search Input */}
            {(onSearchChange || searchValue !== undefined) && (
              <Input
                prefix={<SearchOutlined />}
                placeholder="SEARCH"
                style={{ width: 200 }}
                value={searchValue}
                onChange={onSearchChange}
                allowClear
              />
            )}
            
            {/* Export Actions */}
            {(onExportCSV || onExportPDF) && (
              <div className="dropdown">
                <Button
                  icon={<DownloadOutlined />}
                  className="dropdown-toggle"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  loading={exportLoading}
                >
                  EXPORT
                </Button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  {onExportCSV && (
                    <li>
                      <button 
                        className="dropdown-item" 
                        type="button" 
                        onClick={onExportCSV}
                        disabled={exportLoading}
                      >
                        Export to CSV
                      </button>
                    </li>
                  )}
                  {onExportPDF && (
                    <li>
                      <button 
                        className="dropdown-item" 
                        type="button" 
                        onClick={onExportPDF}
                        disabled={exportLoading}
                      >
                        Export to PDF
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Action Bar Row - Primary Actions on Left */}
      {extraActions && (
        <div className="row align-items-center mb-3">
          {/* Primary Actions (CREATE buttons, etc.) - Left Aligned */}
          <div className="col-12 col-md-6">
            <div className="d-flex justify-content-start">
              {extraActions}
            </div>
          </div>
          
          {/* Additional space for secondary actions if needed */}
          <div className="col-12 col-md-6">
            <div className="d-flex justify-content-md-end justify-content-start mt-2 mt-md-0">
              {/* Reserved for secondary actions */}
            </div>
          </div>
        </div>
      )}
      
      {/* Custom Children */}
      {children && (
        <div className="row">
          <div className="col-12">
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default ResponsiveActionBar;
